// Vendor imports
const _ = require('lodash')
const qs = require('qs')
// Shared imports
const BemEntity = require('shared/bem')
// Client V1 imports
const { track } = require('client/lib/analytics')
const WindowLib = require('client/lib/window')
const Modal = require('client/components/modal')
// Template imports
const mixShareModalTemplate = require('*views/modals/mix-share')

const bem = BemEntity('mix-share-modal')

const HREF_SELECTOR = bem.elementSelector('href')
const COPY_BUTTON_SELECTOR = bem.elementSelector('copy-button')

function shareMixHref(mix, socialMedium) {
  // const {protocol, hostname, port} = window.location
  // Hard-code production URL scheme; cannot share `localhost` links
  const [protocol, hostname, port] = ['https:', 'mix.com', '']
  return protocol + '//' + hostname + (port ? ':' + port : '') +
    '/' + mix.username + '/' + mix.slug +
    '?' + qs.stringify({
      'utm_source': 'pageview',
      'utm_medium': socialMedium,
      'utm_campaign': 'details_share'
    })
}

function socialShareMixHref(mix, socialMedium) {
  const userName = mix.username
  const mixName = mix.name
  const href = shareMixHref(mix, socialMedium)
  switch (socialMedium) {
    case 'facebook': {
      return '//facebook.com/sharer.php?u=' + href
    }
    case 'twitter': {
      const text = mixName + ' By ' + userName + ' ' + href + ' @getmixapp'
      return '//twitter.com/intent/tweet?lang=en' +
        '&text=' + encodeURIComponent(text)
    }
    case 'pinterest': {
      const mixImage = _.get(mix, 'images[0]', wiggin.articlePlaceholder)
      return '//pinterest.com/pin/create/button/' +
        '?url=' + encodeURIComponent(href) +
        '&media=' + encodeURIComponent(mixImage)
    }
    case 'email': {
      const subject = 'Check out this collection on Mix'
      const body =
        'Heyo, \r\n\r\n' +
        'Check out "' + mixName + '" ' +
        'by ' + userName + ' ' +
        'on Mix at ' + href
      return 'mailto:?subject=' + subject +
        '&body=' + encodeURIComponent(body)
    }
    case 'copy':
      return href
  }
}

const shareWindowSizes = {
  'facebook': [555, 625],
  'twitter': [600, 300],
  'pinterest': [750, 750]
}

module.exports = class MixShareModal extends Modal {
  constructor(options) {
    // Handle options
    if (!_.get(options, 'mix.id')) {
      throw Error('Required option `mix` is not an Object with `id` property')
    }
    super(_.defaults(options, {
      modalTemplate: mixShareModalTemplate,
      modalClassName: 'mix-share-modal',
      modalTitle: 'Share'
    }))
  }

  willRender(templateOptions) {
    const { mix } = templateOptions
    const shareHrefs = templateOptions.shareHrefs = {}
    _.each(['copy', 'facebook', 'twitter', 'pinterest', 'email'], socialMedium => {
      shareHrefs[socialMedium] = socialShareMixHref(mix, socialMedium)
    })
  }

  didRender() {
    // Inherit dismissal listeners
    super.didRender()
    // Add social button listeners
    this.$el.on('click', HREF_SELECTOR, this.openShareWindow.bind(this))
    this.$el.on('click', COPY_BUTTON_SELECTOR, this.copyShareUrl.bind(this))
  }

  copyShareUrl(event) {
    event.preventDefault()
    const button = event.currentTarget
    const input = button.form.copy
    input.select()
    document.execCommand('copy')
    button.textContent = 'Copied!'
    this.trackShare('copy')
  }

  openShareWindow(event) {
    const $target = $(event.currentTarget)
    const shareType = $target.attr('data-share-type')
    this.trackShare(shareType)
    if (shareType === 'email') {
      return // Let the browser handle mailto: links
    }
    event.preventDefault()
    const [width, height] = shareWindowSizes[shareType]
    window.open(
      $target.attr('href'),
      `share-${shareType}`,
      WindowLib.centeredWindowFeatures(width, height)
    )
  }

  trackShare(shareType) {
    const { mix } = this.options
    track('share-mix', {
      type: shareType,
      'mix_id': mix.id,
      metabase: {
        'actioned_object_type': 'mix',
        'actioned_object_id': mix.id,
        'extra_properties': shareType
      }
    })
  }

}
